import { lazyLoad } from "./modules/lazy-load";
import { validation } from "./modules/validation/validation";
import { recaptchaDelay } from "./modules/recaptcha-delay";
import { navigation } from "./modules/navigation";

window.addEventListener("load", () => {
  lazyLoad.init();
  navigation.init();
  recaptchaDelay.init();
  validation.init();
});
